import { decompress } from "lz-string";
import { encryptData, decryptData } from "./crypto";

export function preSerialize(data) {
  const { clientState, ...rest } = data;
  let newClientState = clientState;

  if (clientState && Array.isArray(clientState.queries)) {
    const queriesByKey = {};
    clientState.queries.forEach((query) => {
      let keyIdentifier = "";
      if (query.queryKey[0] === "userData") {
        keyIdentifier = "frontendUserData";
      } else if (query.queryKey[0] === "userSessionData") {
        keyIdentifier = "backendUserSessionData";
      } else {
        keyIdentifier = query.queryKey[0];
      }
      queriesByKey[keyIdentifier] = query;
    });
    newClientState = { ...clientState, queries: queriesByKey };
  }

  const jsonString = JSON.stringify({ ...rest, clientState: newClientState });
  return encryptData(jsonString);
}

export function preDeserialize(data) {
  const decryptedString = decryptData(data);
  const parsed = JSON.parse(decryptedString);

  if (
    parsed.clientState &&
    parsed.clientState.queries &&
    typeof parsed.clientState.queries === "object"
  ) {
    const queriesArray = Object.values(parsed.clientState.queries);
    return {
      ...parsed,
      clientState: { ...parsed.clientState, queries: queriesArray },
    };
  }

  return parsed;
}

export function readRawPersistedSessionStorageData() {
  const storedValue = sessionStorage.getItem("REACT_QUERY_OFFLINE_CACHE");
  if (storedValue) {
    const decompressed = decompress(storedValue);
    const readableData = preDeserialize(decompressed);
    return readableData;
  } else {
    console.log("No persisted cache found in sessionStorage");
    return null;
  }
}

export function readCustomFormatPersistedSessionStorageData() {
  const storedValue = sessionStorage.getItem("REACT_QUERY_OFFLINE_CACHE");
  if (storedValue) {
    const decompressed = decompress(storedValue);
    const decryptedString = decryptData(decompressed);
    const parsed = JSON.parse(decryptedString);
    return parsed;
  }
  return null;
}

export function waitForReactQuerySessionCache(
  timeout = 100000,
  interval = 100
) {
  return new Promise((resolve, reject) => {
    const start = Date.now();
    function check() {
      const cache = sessionStorage.getItem("REACT_QUERY_OFFLINE_CACHE");
      if (cache) {
        resolve(true);
      } else if (Date.now() - start > timeout) {
        reject(new Error("Timeout waiting for REACT_QUERY_OFFLINE_CACHE"));
      } else {
        setTimeout(check, interval);
      }
    }
    check();
  });
}
